// Outbound webhook event catalog — must match server WEBHOOK_EVENTS
// (notify-events keys minus retired create events + issue.thread-post). Keys
// flagged v2 are registered but no event source emits them yet, so they
// render disabled.
export const EVENT_OPTIONS: { key: string; label: string; v2?: boolean }[] = [
  { key: "issue.thread-post", label: "thread 新帖" },
  { key: "issue.status", label: "归档重开 / bug 关闭" },
  { key: "issue.owner", label: "owner 指派 / 交接" },
  { key: "engagement.add", label: "PRD 排进版本" },
  { key: "engagement.remove", label: "PRD 移出版本" },
  { key: "version.create", label: "创建版本" },
  { key: "version.rename", label: "版本改名", v2: true },
  { key: "version.publish-log", label: "发布进度更新", v2: true },
  { key: "version.state", label: "版本状态流转" },
  { key: "version.artifact", label: "构建产物上传", v2: true },
  { key: "rc.create", label: "新增 RC 配置", v2: true },
  { key: "rc.state", label: "RC 状态流转", v2: true },
  { key: "rc.ab-close", label: "关闭实验", v2: true },
  { key: "report.submit", label: "提交评审报告", v2: true },
];

export interface Subscription {
  id: string;
  url: string;
  secret: string;
  events: string[];
  pid?: string | null;
  enabled: boolean;
  creator?: { id: string; name?: string } | null;
  createdAt?: string;
}
